// Format price with currency (convert from kobo to naira)
const formatPrice = (
  price: number | null | undefined,
  currency: string = "NGN",
): string => {
  // Handle invalid inputs
  if (price == null || isNaN(Number(price))) {
    return currency ? `0.00` : "0.00";
  }

  // Convert kobo to naira (1 naira = 100 kobo)
  const priceInNaira = Number(price);

  return new Intl.NumberFormat("en-NG", {
    style: "decimal",
    // currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(priceInNaira);
};

export default formatPrice;
